export const DefaultSinceMinutesAgo = 20160; // 14 days